/** External dependecies */
import React, { useEffect } from "react";
import OrderConfirmation from "./OrderConfirmation";
import { viewPage } from "~/assets/js/Api/eventsApi";
import Header from "~/assets/js/components/Header";
import NewFooter from "~/assets/js/components/NewFooter";

const ThankYouApp = () => {
    useEffect(() => {
        setTimeout(() => viewPage(document.title), 500);
    }, []);

    return (
        <>
            <Header />
            <OrderConfirmation />
            <NewFooter />
        </>
    );
};

export default ThankYouApp;
